import React from 'react';
import SimplePage from '../../../../../component/common/landing-page/SimpleFormLandingPage'


export default function SimpleFormLandingPage() {

    return (
        <><SimplePage/></>
    )
}
